import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  standalone: false,
})
export class PageHeaderComponent implements OnInit {
  @Input() title: string;
  @Input() icon;
  @Input() hasClose: boolean;
  @Input() fancyClose: boolean;
  @Output() pageClose = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onClose() {
    this.pageClose.emit();
  }
}
